function get_default_prefs () {
  
  /* This is the source of truth for preferences in DBCSI and their default values.

These prefs relate to picking and configuring a shape from the RDS catalog:  
      prefs.rds_algo: Optional. Default=ee. What type of RDS-Oracle?  ee=Enterprise Edition(BYOL). se=StandardEditon2(LicenseIncluded). custom=RDS Custom
      prefs.optgoal_algo: Optional. Default=min_license. How to pick the best shape?  Options are "min_license" to minimize Oracle Licenses by minimizing the VCPUs or "min_cost" to minimize the AWS shape cost
      prefs.tshape_algo: Optional. Default=N. If Y, then include the CPU-bursting shapes like the T3.
      prefs.extMemShape_algo: Optional. Default=Y. If Y, then include RDS-Oracle extended memory shapes like the db.r5.xlarge.tpc2.mem2x
      prefs.nvme_shape_algo: Optional. Default=N. If Y, then only consider shapes like the r5d which have local NVME storage
      prefs.bursting_algo: Optional. Default=Y. If Y, then consider the burst IOPS and Throughput values when picking shapes.  If N, then only use the baseline IOPS and baseline Throughput values.
      prefs.useRI_algo: Optional. Default=RI+SP. If RI+SP, then consider Savings Plans, Reserved Instance (1 year No Upfront) and OnDemand prices. If SP-Only, then only consider Savings Plans.  If OD, then only use OnDemand pricing. (RI+SP, SP-Only, OD)
      prefs.multiAZ_algo: Optional. Default=N. If Y, then configure for MultiAZ. (auto, Y, N)
      prefs.ebs_algo: Optional. Default=p-gp. If p-gp, then prefer gp2/gp3 if possible.  Other choices are: gp2, gp3, io1, io2
      prefs.rds_baremetal_ranking: Optional. Default=never. When use optgoal_min_license, this controls how to use RDS BareMetal shapes.  Options are never, always, consider0.5.  consider0.5 will assume that a baremetal core can use a licensing core factor of 0.5.  [be sure to check your specific Oracle contract to confirm]
      prefs.aurora_algo: Optional. Aurora PostgreSQL algorithm selection. auro1=Don't size Aurora.  auro5=Use Aurora IO Optimized mode. auro2=Estimate Aurora IO costs as 25% of list price of compute.  auro4=Estimate Aurora IO costs based on IO Throughput metrics. (auro2, auro4, auro5)

These prefs relate to using algorithms to review the raw performance metrics and calculate target values:  
      prefs.cpu_algo: Optional. Default=cpu3. How to calculate CPU target value. Options: cpu1=P99 of averages, cpu2=P90 of peaks, cpu3=Larger of P99 averages OR P90 peaks, cpu4=Larger of P99 averages OR P97 peaks, cpu5=P75 of averages. Add "_plus10" for 10% buffer. (cpu1, cpu1_plus10, cpu2, cpu2_plus10, cpu3, cpu3_plus10, cpu4, cpu4_plus10, cpu5, cpu5_plus10)
      prefs.cpu_thread_ratio: Optional. Default=1.00. CPU thread mapping ratio for non-x86 platforms. The Thread Mapping Ratio is the number of source system threads that are equivalent to 1 Intel thread.
      prefs.diskspace_algo: Optional. Default=disk1_plus15. How to calculate disk space target. Options: disk1=Total DB Size, disk1_plus15=Total DB Size plus 15%. (disk1, disk1_plus15)
      prefs.iops_algo: Optional. Default=iops5. How to calculate IOPS target value. Options: iops2=P99 of averages, iops3=P90 of peaks, iops4=Larger of P99 averages OR P90 peaks, iops5=Larger of P99 averages OR P50 peaks, iops6=Larger of P99 averages OR P97 peaks. Add "_plus10" for 10% buffer. (iops2, iops2_plus10, iops3, iops3_plus10, iops4, iops4_plus10, iops5, iops5_plus10, iops6, iops6_plus10)
      prefs.iomb_algo: Optional. Default=iomb5. How to calculate throughput target value. Options: iomb2=P99 of averages, iomb3=P90 of peaks, iomb4=Larger of P99 averages OR P90 peaks, iomb5=Larger of P99 averages OR P50 peaks, iomb6=Larger of P99 averages OR P97 peaks. Add "_plus10" for 10% buffer. (iomb2, iomb2_plus10, iomb3, iomb3_plus10, iomb4, iomb4_plus10, iomb5, iomb5_plus10, iomb6, iomb6_plus10)
      prefs.memory_algo: Optional. Default=mem2_plus20_2. How to calculate memory target. Options: mem1=sum(SGA+PGA), mem2=sum(SGA+PGA) adjusted for RAC. Add "_plus20_2" for greater of 2GB or 20% buffer. (mem1, mem1_plus20_2, mem2, mem2_plus20_2)
      prefs.smartscan_algo: Optional. Default=ss2. Exadata tuning assumption. Options: ss1=No tuning, ss2=Moderate tuning, ss2a=Light tuning, ss3=Heavy tuning, ss4=Very heavy tuning. (ss1, ss2a, ss2, ss3, ss4)
      prefs.smartscan_minimum: Optional. Default=500. Minimum IO throughput (MB/s) before applying Exadata tuning assumptions
      prefs.exa_memory_algo: Optional. Default=em1. If em1, favor bigger memory target to ease post-Exadata transition.  em0=do not adjust memory. (em0, em1)
      prefs.pdb_algo: Optional. Default=pdb2. PDB metric source. Options: pdb1=Use DBA_HIST_CON_SYSMETRIC_SUMM, pdb2=Use DBA_HIST_RSRC_PDB_METRIC. (pdb1, pdb2)
      prefs.aix_algo: Optional. Default=new. AIX algorithm selection.  new=Multiply the measured CPU usage of AIX by 4 for SMT-8 and by 2.5 for SMT-4.  new2=Multiply the measured CPU usage of AIX by 2.0 for SMT-8 and by 1.8 for SMT-4. none=Do not try to adjust for AIX SMT CPU time reporting. (new, new2, none)
      


        
These are currently out of scope for Public API/MCP needs:
        rac_min_node_algo: "2",
        rac_buffer_algo: "0",
        readreplica_algo: "N",
        readreplica_size_algo: "rr100",
        readreplica_maz_algo: "single",
        readreplica_db_name_match_expr: "",
        readreplica_region: "us-west-2",
        caching_algo: "N",
        caching_minmem: "0",
        ec2fsxn_algo: "N",
        ec2fsxn_baremetal_ranking: "minimumCores",
        ec2fsxn_corefactor: "negativeguess",
        ec2fsxn_shape_scope: "all",
        ec2fsxn_fsxn_generation: "auto",
        ec2fsxn_fsxn_max_filesystems: "4",
        ec2_algo: "N",
        ec2fsxn_baremetal_HA: "single",
        ec2fsxn_baremetal_showdetail: "ec2only",
        rds_baremetal_ranking: "never",
        odbAWS_algo: "N",
        odbAWS_HA: "Y20",
        odbAWS_DR: "Y20",
        odbAWS_StorageStyle: "default",
        odbAWS_adb_nodereserve: "50",
        odbAWS_OCPURounding: "Late",
        odbAWS_Licensing: "BYOL",
        odbAWS_service: "exacs",
        odbAWS_model: "X11M",
        rdsConsolidation_algo: "N",
        rdsConsolidation_maxPDBcount: "3",
        rdsConsolidation_groupbyversion: "N",
        rdsConsolidation_baremetalShape: "x2iezn.metal",
        pdb_and_cdb_exclude_algo: "excludePDB",
        duplicate_database_exclude_algo: "excludeDuplicates",
  */
  
  // Be sure to update dbcsi_api.py if you change any of the default pref values below...
  return {
        cpu_algo: "cpu3",
        cpu_thread_ratio: "1.00",
        diskspace_algo: "disk1_plus15",
        iops_algo: "iops5",
        iomb_algo: "iomb5",
        memory_algo: "mem2_plus20_2",
        ebs_algo: "p-gp",
        multiAZ_algo: "auto",
        rds_algo: "ee",
        tshape_algo: "N",
        extMemShape_algo: "Y",
        rdsSkipShape_preset: "",
        rdsSkipShape_expr: "",
        nvme_shape_algo: "N",
        optgoal_algo: "min_license",
        aurora_algo: "auro1",
        smartscan_algo: "ss2",
        smartscan_minimum: "500",
        exa_memory_algo: "em1",
        pdb_algo: "pdb2",
        useRI_algo: "RI+SP",
        rac_min_node_algo: "2",
        rac_buffer_algo: "0",
        bursting_algo: "Y",
        readreplica_algo: "N",
        readreplica_size_algo: "rr100",
        readreplica_maz_algo: "single",
        readreplica_db_name_match_expr: "",
        readreplica_region: "us-west-2",
        caching_algo: "N",
        caching_minmem: "0",
        ec2fsxn_algo: "N",
        ec2fsxn_baremetal_ranking: "minimumCores",
        ec2fsxn_corefactor: "negativeguess",
        ec2fsxn_shape_scope: "all",
        ec2fsxn_fsxn_generation: "auto",
        ec2fsxn_fsxn_max_filesystems: "4",
        ec2_algo: "N",
        ec2fsxn_baremetal_HA: "single",
        ec2fsxn_baremetal_showdetail: "ec2only",
        aix_algo: "new",
        rds_baremetal_ranking: "never",
        odbAWS_algo: "N",
        odbAWS_HA: "Y20",
        odbAWS_DR: "Y20",
        odbAWS_StorageStyle: "default",
        odbAWS_adb_nodereserve: "50",
        odbAWS_OCPURounding: "Late",
        odbAWS_Licensing: "BYOL",
        odbAWS_service: "exacs",
        odbAWS_model: "X11M",
        rdsConsolidation_algo: "N",
        rdsConsolidation_maxPDBcount: "3",
        rdsConsolidation_groupbyversion: "N",
        rdsConsolidation_baremetalShape: "x2iezn.metal",
        pdb_and_cdb_exclude_algo: "excludePDB",
        duplicate_database_exclude_algo: "excludeDuplicates",
        asv_min_storage: "32000",
        standard_recommendation_version: 10
      };
}


function calculate_target_values (batchParams) {

// See https://quip-amazon.com/JNHtAHYe53lR/DBCSI-External-Integrations


    var data = JSON.parse(JSON.stringify(batchParams.body.inputs));
    var prefs = batchParams.body.prefs;
    var assumptionsArray = [];
    
    //fix a few things that are not compatible. (dont adjust memory for rac-to-single-instance if sizing for rac)
    // console.log("prefs",prefs);
    if (prefs.rds_algo=="rac" && prefs.memory_algo=="mem2") { 
      // console.log("mem2-mem1"); 
      prefs.memory_algo="mem1";
    }
    if (prefs.rds_algo=="rac" && prefs.memory_algo=="mem2_plus20_2") { 
      // console.log("mem2-mem1"); 
      prefs.memory_algo="mem1_plus20_2";
    }
    

      if (prefs.cpu_algo=="cpu1") assumptionsArray.push({category: "VCPU", text: "P99 of the averages"});
      if (prefs.cpu_algo=="cpu1_plus10") assumptionsArray.push({category: "VCPU", text: "P99 of the averages, plus 10%"});
      if (prefs.cpu_algo=="cpu2") assumptionsArray.push({category: "VCPU", text: "P90 of the peaks"});
      if (prefs.cpu_algo=="cpu2_plus10") assumptionsArray.push({category: "VCPU", text: "P90 of the peaks, plus 10%"});
      if (prefs.cpu_algo=="cpu3") assumptionsArray.push({category: "VCPU", text: "Larger of the P99 of the averages OR the P90 of the peaks"});
      if (prefs.cpu_algo=="cpu3_plus10") assumptionsArray.push({category: "VCPU", text: "Larger of the P99 of the averages OR the P90 of the peaks, plus 10%"});
      if (prefs.cpu_algo=="cpu4") assumptionsArray.push({category: "VCPU", text: "Larger of the P99 of the averages OR the P97 of the peaks"});
      if (prefs.cpu_algo=="cpu4_plus10") assumptionsArray.push({category: "VCPU", text: "Larger of the P99 of the averages OR the P97 of the peaks, plus 10%"});
      if (prefs.cpu_algo=="cpu5") assumptionsArray.push({category: "VCPU", text: "P75 of the averages"});
      if (prefs.cpu_algo=="cpu5_plus10") assumptionsArray.push({category: "VCPU", text: "P75 of the averages, plus 10%"});

      if ((data.PLATFORM_NAME!="Linux_x86_64-bit")&&(data.PLATFORM_NAME!="Microsoft_Windows_x86_64-bit") &&(data.PLATFORM_NAME!="Assume x86")) {
        assumptionsArray.push({category: "CPU_Thread", text: "x86 CPU Thread Mapping Ratio of "+prefs.cpu_thread_ratio });
      }
      
      if (prefs.memory_algo=="mem1") assumptionsArray.push({category: "Memory", text: "sum(SGA+PGA)"});
      if (prefs.memory_algo=="mem1_plus20_2") assumptionsArray.push({category: "Memory", text: "sum(SGA+PGA), plus greater of 2GB or 20%"});
      if (prefs.memory_algo=="mem2") assumptionsArray.push({category: "Memory", text: "sum(SGA+PGA) adjusted for RAC"});
      if (prefs.memory_algo=="mem2_plus20_2") assumptionsArray.push({category: "Memory", text: "sum(SGA+PGA) adjusted for RAC, plus greater of 2GB or 20%"});

      if (prefs.iomb_algo=="iomb2") assumptionsArray.push({category: "Throughput", text: "P99 of the averages"});
      if (prefs.iomb_algo=="iomb2_plus10") assumptionsArray.push({category: "Throughput", text: "P99 of the averages, plus 10%"});
      if (prefs.iomb_algo=="iomb3") assumptionsArray.push({category: "Throughput", text: "P90 of the peaks"});
      if (prefs.iomb_algo=="iomb3_plus10") assumptionsArray.push({category: "Throughput", text: "P90 of the peaks, plus 10%"});
      if (prefs.iomb_algo=="iomb5") assumptionsArray.push({category: "Throughput", text: "Larger of the P99 of the averages OR the P50 of the peaks"});
      if (prefs.iomb_algo=="iomb5_plus10") assumptionsArray.push({category: "Throughput", text: "Larger of the P99 of the averages OR the P50 of the peaks, plus 10%"});
      if (prefs.iomb_algo=="iomb4") assumptionsArray.push({category: "Throughput", text: "Larger of the P99 of the averages OR the P90 of the peaks"});
      if (prefs.iomb_algo=="iomb4_plus10") assumptionsArray.push({category: "Throughput", text: "Larger of the P99 of the averages OR the P90 of the peaks, plus 10%"});
      if (prefs.iomb_algo=="iomb6") assumptionsArray.push({category: "Throughput", text: "Larger of the P99 of the averages OR the P97 of the peaks"});
      if (prefs.iomb_algo=="iomb6_plus10") assumptionsArray.push({category: "Throughput", text: "Larger of the P99 of the averages OR the P97 of the peaks, plus 10%"});


      if (prefs.iops_algo=="iops2") assumptionsArray.push({category: "IOPS", text: "P99 of the averages"});
      if (prefs.iops_algo=="iops2_plus10") assumptionsArray.push({category: "IOPS", text: "P99 of the averages, plus 10%"});
      if (prefs.iops_algo=="iops3") assumptionsArray.push({category: "IOPS", text: "P90 of the peaks"});
      if (prefs.iops_algo=="iops3_plus10") assumptionsArray.push({category: "IOPS", text: "P90 of the peaks, plus 10%"});
      if (prefs.iops_algo=="iops5") assumptionsArray.push({category: "IOPS", text: "Larger of the P99 of the averages OR the P50 of the peaks"});
      if (prefs.iops_algo=="iops5_plus10") assumptionsArray.push({category: "IOPS", text: "Larger of the P99 of the averages OR the P50 of the peaks, plus 10%"});
      if (prefs.iops_algo=="iops4") assumptionsArray.push({category: "IOPS", text: "Larger of the P99 of the averages OR the P90 of the peaks"});
      if (prefs.iops_algo=="iops4_plus10") assumptionsArray.push({category: "IOPS", text: "Larger of the P99 of the averages OR the P90 of the peaks, plus 10%"});
      if (prefs.iops_algo=="iops6") assumptionsArray.push({category: "IOPS", text: "Larger of the P99 of the averages OR the P97 of the peaks"});
      if (prefs.iops_algo=="iops6_plus10") assumptionsArray.push({category: "IOPS", text: "Larger of the P99 of the averages OR the P97 of the peaks, plus 10%"});

      if (prefs.diskspace_algo=="disk1") assumptionsArray.push({category: "DiskSpace", text: "Total DB Size"});
      if (prefs.diskspace_algo=="disk1_plus15") assumptionsArray.push({category: "DiskSpace", text: "Total DB Size, plus 15%"});

      if (data.IS_PDB=="YES") {
        if (prefs.pdb_algo=="pdb1") assumptionsArray.push({category: "PDBmetric", text: "Use Oracle's DBA_HIST_CON_SYSMETRIC_SUMM table for PDB-level CPU and IO Throughput"});
        if (prefs.pdb_algo=="pdb2") assumptionsArray.push({category: "PDBmetric", text: "Use Oracle's DBA_HIST_RSRC_PDB_METRIC table for PDB-level CPU and IO Throughput"});
      }
      
      if (data.Exadata=='Yes') {
        if (prefs.smartscan_algo=="ss1") assumptionsArray.push({category: "ExadataTuning", text: "No - assume no ex-SmartScan adjustments (such as query tuning, indexes, materialized views, ...)"});
        if (prefs.smartscan_algo=="ss2a" ) assumptionsArray.push({category: "ExadataTuning", text: "Yes(Light) - assume some light tuning to reduce I/O Throughput"});
        if (prefs.smartscan_algo=="ss2" ) assumptionsArray.push({category: "ExadataTuning", text: "Yes(Moderate) - assume some moderate tuning to reduce I/O Throughput"});
        if (prefs.smartscan_algo=="ss3" ) assumptionsArray.push({category: "ExadataTuning", text: "Yes(Heavy) - assume some heavy tuning to reduce I/O Throughput"});
        if (prefs.smartscan_algo=="ss4" ) assumptionsArray.push({category: "ExadataTuning", text: "Yes(Very Heavy) - assume some very heavy tuning to reduce I/O Throughput"});

        assumptionsArray.push({category: "ExadataIOThreshold", text: "minimum IO throughput of "+prefs.smartscan_minimum+ " MB/s before applying tuning assumption"});

        if (prefs.exa_memory_algo=="em1") assumptionsArray.push({category: "ExadataMemory", text: "Yes - favor a bigger Memory target to ease post-Exadata transition"});

      }

      //technically, these arent target value assumtions and may get out of date in manual edit (but we don't show this after manual edit)
      if (prefs.nvme_shape_algo=="Y") assumptionsArray.push({category: "LocalNVME", text: "Only consider shapes with local storage (e.g. r5d,m5d,r6id,...)"});
      if (prefs.tshape_algo=="Y") assumptionsArray.push({category: "TShape", text: "Consider T-shapes (burstable CPU)"});
      if (prefs.extMemShape_algo=="N") assumptionsArray.push({category: "ExtMemoryShape", text: "Do not consider RDS Extended Memory shapes"});
      let skipShape = resolve_skip_shape_filter(prefs);
      if (skipShape.expr != "") {
        let skipText = skipShape.preset ? skipShape.preset.text : "Skip shapes matching the pattern " + skipShape.expr;
        assumptionsArray.push({category: "SkipShape", text: skipText + "; applies to RDS-Oracle, Aurora, EC2, and EC2+FSxN shapes"});
      }
      if (prefs.bursting_algo=="N") assumptionsArray.push({category: "IOBursting", text: "Only consider baseline IO performance for Compute shapes and FSx-OnTap storage"});
      if (prefs.useRI_algo=="OD") assumptionsArray.push({category: "RIs", text: "Use only OnDemand pricing"});
      if (prefs.useRI_algo=="SP-Only") assumptionsArray.push({category: "RIs", text: "Use only Database Savings Plans pricing"});
      if (prefs.optgoal_algo=="Y") assumptionsArray.push({category: "LicenseVsCost", text: "Use Optimize CPU (picks RDS shape based on cost and right-sized provisioned VCPU)"});
      if (prefs.optgoal_algo=="min_license") assumptionsArray.push({category: "LicenseVsCost", text: "Pick RDS shape to minimize VCPU (minimize licensing)"});
      if (prefs.optgoal_algo=="min_cost") assumptionsArray.push({category: "LicenseVsCost", text: "Pick RDS shape by lowest AWS cost (license quantity does not matter- good for Oracle ULAs)"});
      if (prefs.rds_algo=="rac" && (prefs.rac_buffer_algo=="10") ) assumptionsArray.push({category: "RACbuffer", text: "Add a target value of buffer of 10% when calculating RAC node requirements"});
      if (prefs.rds_algo=="rac" && (prefs.rac_min_node_algo=="3") ) assumptionsArray.push({category: "RACnodes", text: "Use a minimum of 3 nodes"});

     // if (prefs.rds_baremetal_ranking=="never") assumptionsArray.push({category: "RDSBareMetal", text: "Use Optimize CPU (picks RDS shape based on cost and right-sized provisioned VCPU)"});
      if (prefs.rds_baremetal_ranking=="always") assumptionsArray.push({category: "RDSBareMetal", text: "Only consider bare metal shapes for RDS"});
      if (prefs.rds_baremetal_ranking=="consider0.5") assumptionsArray.push({category: "RDSBareMetal", text: "User wishes to assume 0.5 core factor with bare metal shapes"});
     // if (prefs.rds_baremetal_ranking=="consider1.0") assumptionsArray.push({category: "RDSBareMetal", text: "Ignore Optimize CPU and pick RDS shape by lowest AWS cost (license quantity does not matter- good for Oracle ULAs)"});


      if (prefs.rdsConsolidation_algo=="Y1") assumptionsArray.push({category: "RDSConsolidation", text: "Use Consolidation Algorithm #1"});
      if (prefs.rdsConsolidation_algo=="Y2") assumptionsArray.push({category: "RDSConsolidation", text: "Merge instances together and consider other shapes with same VCPU"});
      if (prefs.rdsConsolidation_algo=="baremetal") assumptionsArray.push({category: "RDSConsolidation", text: "Use only RDS-Oracle bare metal shapes to consolidate databases"});
      if (prefs.rdsConsolidation_algo=="baremetal") assumptionsArray.push({category: "RDSConsolidation", text: "Preferred shape="+prefs.rdsConsolidation_baremetalShape});
      if (prefs.rdsConsolidation_algo!="N") assumptionsArray.push({category: "RDSConsolidation", text: "Max PDBs per CDB="+prefs.rdsConsolidation_maxPDBcount});
      if ((prefs.rdsConsolidation_algo!="N") && (prefs.rdsConsolidation_groupbyversion=="Y")) assumptionsArray.push({category: "RDSConsolidation", text: "Group by Version"});

      if (prefs.readreplica_algo=="Y") assumptionsArray.push({category: "RDSReplica", text: "Add Replicas"});
     // if (prefs.readreplica_algo!="N") assumptionsArray.push({category: "RDSReplica", text: "Replica Region="+prefs.readreplica_region});
      if ((prefs.readreplica_algo!="N") && (prefs.readreplica_size_algo=="rr100")) assumptionsArray.push({category: "RDSReplica", text: "Size Replica instance equivalent to primary"});
      if ((prefs.readreplica_algo!="N") && (prefs.readreplica_size_algo=="rr50")) assumptionsArray.push({category: "RDSReplica", text: "Size Replica instance at 50% of primary"});
      if ((prefs.readreplica_algo!="N") && (prefs.readreplica_size_algo=="rr25")) assumptionsArray.push({category: "RDSReplica", text: "Size Replica instance at 25% of primary"});


      if (prefs.asv_min_storage && prefs.asv_min_storage!="" && data.TOTAL_DB_SIZE_GB*1.2 >= prefs.asv_min_storage*1 ) {
        // && data.TOTAL_DB_SIZE_GB*1.2 >= prefs.asv_min_storage*1
        // console.log("ASV", data.DiskSpace, data.TOTAL_DB_SIZE_GB, data);
        assumptionsArray.push({category: "AddlStorageVolumes", text: "Consider Additional Storage Volumes if diskspace is > " + prefs.asv_min_storage + "GB"});
      }  

      
      if (prefs.caching_algo && prefs.caching_algo!="N") {
        var cacheReduce = 0;
        if (prefs.caching_algo=="ec25") cacheReduce=25;
        if (prefs.caching_algo=="ec50") cacheReduce=50;
        if (prefs.caching_algo=="ec65") cacheReduce=65;
        assumptionsArray.push({category: "Caching", text: "Use ElastiCache and model a " + cacheReduce + "% reduction in RDS resources.  Size ElastiCache memory to be at least 1/3 the size of reduction in the target RDS SGA"});
      }  
      
      if (prefs.ec2fsxn_algo && prefs.ec2fsxn_algo!="N") {
        var ec2_scope_label = (prefs.ec2fsxn_shape_scope=="all") ? "EC2" : "EC2 Bare Metal";
        var ec2_picking = "Pick " + ec2_scope_label + " shape with the fastest cores";
        if (prefs.ec2fsxn_baremetal_ranking=="minimumCost") ec2_picking = "Pick " + ec2_scope_label + " shape with the lowest shape cost";
        if (prefs.ec2fsxn_baremetal_ranking=="minimumCores") ec2_picking = "Pick " + ec2_scope_label + " shape with fewest total cores";
        var corefactor = " and guess Core Factor while treating ambiguity positively";
        if (prefs.ec2fsxn_corefactor=="negativeguess") corefactor = " and guess Core Factor while treating ambiguity negatively";
        if (prefs.ec2fsxn_corefactor=="N") corefactor = " and do not consider Core Factor";

        if (prefs.ec2fsxn_shape_scope=="all") assumptionsArray.push({category: "EC2", text: "Consider all EC2 shapes (regular or Bare Metal, excluding Graviton); regular EC2 is BYOL, vCPU-licensed (2 vCPU = 1 Oracle processor license)"});
        assumptionsArray.push({category: "EC2", text: ec2_picking+ corefactor});

        if ((prefs.ec2fsxn_fsxn_generation || "auto")=="auto") assumptionsArray.push({category: "FSx-OnTap", text: "Price both first-generation (Gen1) and second-generation (Gen2) FSx-OnTap file systems and use the less expensive one"});
        else if (prefs.ec2fsxn_fsxn_generation=="Gen2") assumptionsArray.push({category: "FSx-OnTap", text: "Use second-generation (Gen2) FSx-OnTap file systems (Single-AZ 2 scales out to 12 HA pairs; Multi-AZ 2 uses 1 HA pair)"});
        else assumptionsArray.push({category: "FSx-OnTap", text: "Use first-generation (Gen1) FSx-OnTap file systems"});
        var max_fs = prefs.ec2fsxn_fsxn_max_filesystems || "4";
        if (max_fs != "1") assumptionsArray.push({category: "FSx-OnTap", text: "Use up to " + max_fs + " FSx-OnTap file systems when that saves at least 20% versus fewer file systems"});

        if (prefs.ec2fsxn_baremetal_HA=="single") assumptionsArray.push({category: "EC2-HA", text: "MultiAZ Estimates only include an EC2 instance in the primary AZ"});
        if (prefs.ec2fsxn_baremetal_HA=="Y") assumptionsArray.push({category: "EC2-HA", text: "MultiAZ Estimates include EC2 instances in both AZs"});
      }
// console.log("prefsXXX", prefs);
      // assumptionsArray.push({category: "Region", text: +regionInfo.region});

      //if memory is missing
      
      if ((data.DB_SGAPGA_TOTAL==undefined)||(data.DB_SGAPGA_TOTAL*1<1)) {
        data.Memory=6;
        data.memory_target_comments = data.memory_target_comments + "[SGA/PGA data is missing.  Assuming 6GB] ";
      } else {
        data.Memory=data.DB_SGAPGA_TOTAL;
      }
      
      //apply prefs to memory
      if ((prefs.memory_algo=="mem2") || (prefs.memory_algo=="mem2_plus20_2")) {
        //down-adjust for RAC.
        //take SGA+PGA for 1 instance and add 0.5 per additional instance
        data.Memory = data.Memory/data.NUM_INSTANCES * (1+ (data.NUM_INSTANCES-1)*0.5);
      }  
      if ((prefs.memory_algo=="mem1_plus20_2") || (prefs.memory_algo=="mem2_plus20_2")) {
        // console.log("here i am!!!!!");
        data.Memory = (data.Memory+Math.max(data.Memory*0.2,2));
      } 
      data.Memory = data.Memory.toFixed(0);


       
      // calculate IO throughput
      data.Throughput = data.DB_IOMB_AVERAGE_P99;
      if (data.IS_PDB=="YES" && (prefs.pdb_algo=="pdb2") ) {
        data.Throughput=data.DB_PDB2_IOMB_AVERAGE_P99;
        
            data.iomb_target_comments = data.iomb_target_comments + "[peak IO Throughput metrics not available.  Using p99 of the average instead] ";
            data.DB_IOMB_PEAKS_P90=data.DB_PDB2_IOMB_AVERAGE_P99;
            data.DB_IOMB_PEAKS_P50=data.DB_PDB2_IOMB_AVERAGE_P99;
            data.DB_IOMB_PEAKS_P97=data.DB_PDB2_IOMB_AVERAGE_P99;

      }
      
      if ((prefs.iomb_algo!='iomb1')&&(prefs.iomb_algo!='iomb1_plus10')) {

        if ((prefs.iomb_algo=='iomb2')||(prefs.iomb_algo=='iomb2_plus10')) {
          data.Throughput=data.Throughput.toFixed(0);
        }
        if ((prefs.iomb_algo=='iomb3')||(prefs.iomb_algo=='iomb3_plus10')) {
          data.Throughput=(data.DB_IOMB_PEAKS_P90*1).toFixed(0);
        }
        if ((prefs.iomb_algo=='iomb4')||(prefs.iomb_algo=='iomb4_plus10')) {
          data.Throughput=Math.max(data.Throughput, (data.DB_IOMB_PEAKS_P90*1)).toFixed(0);
        }
        if ((prefs.iomb_algo=='iomb5')||(prefs.iomb_algo=='iomb5_plus10')) {
            data.Throughput=Math.max(data.Throughput, (data.DB_IOMB_PEAKS_P50*1)).toFixed(0);
          }
        if ((prefs.iomb_algo=='iomb6')||(prefs.iomb_algo=='iomb6_plus10')) {
            data.Throughput=Math.max(data.Throughput, (data.DB_IOMB_PEAKS_P97*1)).toFixed(0);
          }
          
      }
      
      //add plus10 to iomb
      if (prefs.iomb_algo.indexOf('plus10')>0) {
        data.Throughput = (data.Throughput*1.1).toFixed(0);
      }
      


      // calculate IOPS 
      data.IOPS=data.DB_IOPS_AVERAGE_P99;
      if (data.IS_PDB=="YES"  ) {
            data.iops_target_comments = data.iops_target_comments + "[peak IOPS metrics not available.  Using p99 of the average instead] ";
            data.DB_IOPS_PEAKS_P90=data.DB_IOPS_AVERAGE_P99;
            data.DB_IOPS_PEAKS_P50=data.DB_IOPS_AVERAGE_P99;
            data.DB_IOPS_PEAKS_P97=data.DB_IOPS_AVERAGE_P99;
      }
     
      if ((prefs.iops_algo!='iops1')&&(prefs.iops_algo!='iops1_plus10')) {
         let max_average = data.DB_IOPS_AVERAGE_P99 * 1;


        if ((prefs.iops_algo=='iops2')||(prefs.iops_algo=='iops2_plus10')) {
          data.IOPS=max_average.toFixed(0);
        }
        if ((prefs.iops_algo=='iops3')||(prefs.iops_algo=='iops3_plus10')) {
          data.IOPS=(data.DB_IOPS_PEAKS_P90*1).toFixed(0);
        }
        if ((prefs.iops_algo=='iops4')||(prefs.iops_algo=='iops4_plus10')) {
          data.IOPS=Math.max(max_average, (data.DB_IOPS_PEAKS_P90*1)).toFixed(0);
        }
        if ((prefs.iops_algo=='iops5')||(prefs.iops_algo=='iops5_plus10')) {
            data.IOPS=Math.max(max_average, (data.DB_IOPS_PEAKS_P50*1)).toFixed(0);
          }
        if ((prefs.iops_algo=='iops6')||(prefs.iops_algo=='iops6_plus10')) {
            data.IOPS=Math.max(max_average, (data.DB_IOPS_PEAKS_P97*1)).toFixed(0);
          }
          
      }
      
      //add plus10 to iops
      if (prefs.iops_algo.indexOf('plus10')>0) {
        data.IOPS = (data.IOPS*1.1).toFixed(0);
      }


     //apply prefs to Diskspace
      data.DiskSpace = data.TOTAL_DB_SIZE_GB;
      
      //check to see if TOTAL_PDB_SIZE_GB exists. If so add it
      if (data.TOTAL_PDB_SIZE_GB) {
        
        if (data.TOTAL_PDB_SIZE_GB*1>0) {
          data.diskspace_target_comments = "When data was collected via awr_miner.sql, your Oracle user did not have visibility into the size of the PDB datafiles.  Therefore, we adjusted the CDB storage originally seen ("+data.TOTAL_DB_SIZE_GB+
            "GB) by adding the total disk space of its child PDBs known to DBCSI ("+ data.TOTAL_PDB_SIZE_GB+"GB).";
          if (prefs.diskspace_algo=="disk1_plus15") {
            data.diskspace_target_comments += " This is done prior to the plus 15% calculation.";
          }
          // console.log(data.diskspace_target_comments);  
          data.DiskSpace = (data.TOTAL_DB_SIZE_GB*1 + data.TOTAL_PDB_SIZE_GB*1).toFixed(0);
        } else {
          data.diskspace_target_comments = "You are missing visibility into the size of the PDB datafiles (due to the fact that the Oracle user who ran the awr_miner.sql script did not have CONTAINER_DATA=all permission).  To compensate, DBCSI attempted to find child PDBs for this CDB but could not.  Your storage space (GB) target value is likely under-reported.";
        }
      }
      
      if ((prefs.diskspace_algo=="disk1_plus15") ) {
        // console.log("here i am!!!!!");
        data.DiskSpace = (data.DiskSpace*1.15).toFixed(0);
      } 

      
 
      




      //apply prefs to cpu
      data.VCPU = data.DB_CPU_THREADS_AVERAGE_P99;
      if (data.IS_PDB=="YES" && (prefs.pdb_algo=="pdb2") ) {
        
        if ((prefs.cpu_algo=='cpu5')||(prefs.cpu_algo=='cpu5_plus10')) {
             data.VCPU=data.DB_PDB2_CPU_THREADS_AVERAGE_P75;
             data.DB_CPU_THREADS_PEAKS_P90=data.DB_PDB2_CPU_THREADS_AVERAGE_P75;
             data.DB_CPU_THREADS_PEAKS_P97=data.DB_PDB2_CPU_THREADS_AVERAGE_P75;
        } else {  
            data.VCPU=data.DB_PDB2_CPU_THREADS_AVERAGE_P99;

            data.cpu_target_comments = data.cpu_target_comments + "[peak CPU metrics not available.  Using p99 of the average instead] ";
            data.DB_CPU_THREADS_PEAKS_P90=data.DB_PDB2_CPU_THREADS_AVERAGE_P99;
            data.DB_CPU_THREADS_PEAKS_P97=data.DB_PDB2_CPU_THREADS_AVERAGE_P99;
        }    
      }

      if ((prefs.cpu_algo!='cpu1')&&(prefs.cpu_algo!='cpu1_plus10')) {
        let p90_peak = data.DB_CPU_THREADS_PEAKS_P90;
        

        if ((prefs.cpu_algo=='cpu2')||(prefs.cpu_algo=='cpu2_plus10')) {
          data.VCPU=(p90_peak*1);
        }
        if ((prefs.cpu_algo=='cpu3')||(prefs.cpu_algo=='cpu3_plus10')) {
          data.VCPU=Math.max(data.VCPU*1, (p90_peak*1));
        }
        if ((prefs.cpu_algo=='cpu4')||(prefs.cpu_algo=='cpu4_plus10')) {
          data.VCPU=Math.max(data.VCPU*1, (data.DB_CPU_THREADS_PEAKS_P97*1));
        }
        
      }
      // Handle P75 of averages
      if ((prefs.cpu_algo=='cpu5')||(prefs.cpu_algo=='cpu5_plus10')) {
        data.VCPU = data.DB_CPU_THREADS_AVERAGE_P75;
        if (data.IS_PDB=="YES" && (prefs.pdb_algo=="pdb2") ) {
          data.VCPU=data.DB_PDB2_CPU_THREADS_AVERAGE_P75;
        }
      }      

      
      //add plus10 to cpu
      if (prefs.cpu_algo.indexOf('plus10')>0) {
        data.VCPU = (data.VCPU*1.1);
      }

      // adjust threads for AIX
      if ((data.PLATFORM_NAME=='AIX-Based_Systems_(64-bit)') && (data.AIX_CPU_ADJUSTMENT*1>0) && (prefs.aix_algo!="none")) {
        data.AIX_CPU_ADJUSTMENT_USED =data.AIX_CPU_ADJUSTMENT*1; 
        if (prefs.aix_algo=="old") {
          data.AIX_CPU_ADJUSTMENT_USED =data.AIX_CPU_ADJUSTMENT*1; 
        } else if (prefs.aix_algo=="new") {
          data.AIX_CPU_ADJUSTMENT_USED = (data.AIX_CPU_ADJUSTMENT*1) == 8 ? 4 : 2.5;
        } else if (prefs.aix_algo=="new2") {
          data.AIX_CPU_ADJUSTMENT_USED =(data.AIX_CPU_ADJUSTMENT*1) == 8 ? 2.0 : 1.8;
        }   
        data.VCPU = (1*data.VCPU*( data.AIX_CPU_ADJUSTMENT_USED ) );
        data.cpu_target_comments=data.cpu_target_comments + `[adjusting source AIX CPU Usage based on SMT CPU time adjustment multiplier of ${data.AIX_CPU_ADJUSTMENT_USED}] `;
        
      }
      
      // convert threads for non-x86
      if ((data.PLATFORM_NAME!="Linux_x86_64-bit")&&(data.PLATFORM_NAME!="Microsoft_Windows_x86_64-bit")&&(data.PLATFORM_NAME!="Assume x86") ) {
        data.VCPU = (1*data.VCPU/(prefs.cpu_thread_ratio*1));
       data.cpu_thread_ratio = prefs.cpu_thread_ratio;  
       data.cpu_target_comments=data.cpu_target_comments + `[adjusting VCPU based on x86 CPU Thread Mapping Ratio of ${prefs.cpu_thread_ratio}] `;

        
      }
      //round data just in case
      data.VCPU = (1*data.VCPU).toFixed(1);

      // calculate UseMaz
      if (prefs.multiAZ_algo == "auto") {
        data.UseMAZ = 'No';
        if (data.NUM_INSTANCES*1 > 1) {
          data.UseMAZ = 'Yes';
        }
      }
      if (prefs.multiAZ_algo == "N") {
      data.UseMAZ = 'No';
      }
      if (prefs.multiAZ_algo == "Y") {
        data.UseMAZ = 'Yes';
      }
      

      // calculate UseRI and optgoal_choice
        data.UseRI = prefs.useRI_algo;
        data.optgoal_choice = prefs.optgoal_algo;
      //  data.cpu_thread_ratio = prefs.cpu_thread_ratio;
      //  data.pdb_algo = prefs.pdb_algo;
      //  data.smartscan_algo = prefs.smartscan_algo;
      //  data.smartscan_minimum = prefs.smartscan_minimum;
      //  data.nvme_shape_algo = prefs.nvme_shape_algo;   
       // data.tshape_algo = prefs.tshape_algo;
      //  data.extMemShape_algo = prefs.extMemShape_algo;
      
      // above, we used to store prefs one by one, but now we just store them all.
      // in future, maybe clean this up...
      data.frozen_prefs = prefs;
      // note: we overwrite this again when you create scenarios

 
      //now apply Exadata Adjustment
      
      //start with Exadata memory adjustment
      
      
      if ( (data.Exadata=='Yes') && (prefs.exa_memory_algo=="em1") ) {
        
        //only kick in if IO Throughput is >=2000MB
        if (data.Throughput*1>=2000) {
          data.OrigMemory = data.Memory;
          let newmemory = data.OrigMemory;
          //first multiple memory
          newmemory = newmemory * 2;
          // console.log("memory1", newmemory);
          //next make memory at least 8GB per VCPU (same ratio as R family)
          newmemory = Math.max(newmemory, data.VCPU*8);
          // console.log("memory2", newmemory);
          //next make memory at least x% of original IO Throughput
          newmemory = Math.max(newmemory, data.Throughput * 0.05);
          // console.log("memory3", newmemory);
          //sanity check- don't force memory > 300GB unlesss the origmemory was
          newmemory = Math.max(data.OrigMemory, Math.min(newmemory, 300));
          // console.log("memory4", newmemory);
          
          
          data.Memory = newmemory.toFixed(0);
          
          if (data.Memory*1 > data.OrigMemory*1) {
            data.memory_target_comments += `[increasing suggested Memory target from ${data.OrigMemory} GB to ${data.Memory} GB to help post-Exadata transition] `;
          }  
        }  
        
      }
      
      //now do Exadata IO adjustments
      data.OrigThroughput = data.Throughput;
      data.OrigIOPS = data.IOPS;
      
        //issue: in PDBs, we sometimes see DB_IOMB_AVERAGE_P99 be less than DB_EXA_CELL_BYTES_ELIG_MB_P99
        //that should not happen
        //issue2: in PDBs, we also sometimes see DB_EXA_CELL_BYTES_ELIG_MB_P99 = null
        if (data.IS_PDB=='YES') {
          let newDB_EXA_CELL_BYTES_ELIG_MB_P99 = data.DB_EXA_CELL_BYTES_ELIG_MB_P99;
          if (!newDB_EXA_CELL_BYTES_ELIG_MB_P99) {
            newDB_EXA_CELL_BYTES_ELIG_MB_P99 = 0;
          }
          newDB_EXA_CELL_BYTES_ELIG_MB_P99 = Math.min(newDB_EXA_CELL_BYTES_ELIG_MB_P99,data.DB_IOMB_AVERAGE_P99);
          let newDB_EXA_CELL_SI_SAVE_MB_P99 = Math.min(data.DB_EXA_CELL_SI_SAVE_MB_P99, newDB_EXA_CELL_BYTES_ELIG_MB_P99);
          //fix the data
          data.DB_EXA_CELL_BYTES_ELIG_MB_P99 = newDB_EXA_CELL_BYTES_ELIG_MB_P99;
          data.DB_EXA_CELL_SI_SAVE_MB_P99 = newDB_EXA_CELL_SI_SAVE_MB_P99;
        }
      

      if ((data.Exadata=='Yes')&&(prefs.smartscan_algo!='ss1')&&(data.Throughput*1>prefs.smartscan_minimum*1)&&(data.DB_EXA_CELL_BYTES_ELIG_MB_P99*1>0)) {
        // let ss_string='Moderate';
        // let ss_si_ratio=4;
        // let ss_nonsi_ratio=2;
        // if (prefs.smartscan_algo=='ss3') {
        //   ss_string='Heavy';
        //   ss_si_ratio=8;
        //   ss_nonsi_ratio=4;
        // }
        // if (prefs.smartscan_algo=='ss4') {
        //   ss_string='Very Heavy';
        //   ss_si_ratio=12;
        //   ss_nonsi_ratio=6;
        // }
        // if (prefs.smartscan_algo=='ss2a') {
        //   ss_string='Light';
        //   ss_si_ratio=2;
        //   ss_nonsi_ratio=1.5;
        // }
        

        
        // let newSI=data.DB_EXA_CELL_SI_SAVE_MB_P99/ss_si_ratio;
        // let newNonSI=(data.DB_EXA_CELL_BYTES_ELIG_MB_P99-data.DB_EXA_CELL_SI_SAVE_MB_P99)/ss_nonsi_ratio;
        // //ThroughputMaxAverage may be higher than SSE because it includes non SSE items, so recalculte it
        // let newThroughputMaxAverage = data.DB_IOMB_AVERAGE_P99-data.DB_EXA_CELL_BYTES_ELIG_MB_P99+newSI+newNonSI;
        // //Throughput target value may be based on peaks as well as averages (but Exadata SSE, SI, etc are based on averages).  Scale the new throughput proportionally
        // let newExadataRatio = data.DB_IOMB_AVERAGE_P99 / newThroughputMaxAverage;
        // let newThroughput = data.Throughput / newExadataRatio;
        
        // data.iomb_target_comments=data.iomb_target_comments + `[using ${ss_string} post-Exadata SmartScan Tuning Assumption to estimate/reduce I/O Throughput target from ${data.Throughput}MB/s to ${newThroughput.toFixed(0)}MB/s] `;
        // data.ExadataAdjustmentText=` [assumes ${ss_string} post-Exadata SmartScan Tuning to estimate/reduce I/O Throughput target from ${data.Throughput}MB/s to ${newThroughput.toFixed(0)}MB/s]`;
        // data.Throughput = newThroughput.toFixed(0);
        // data.ExadataAdjustment = newExadataRatio;

        // //also adjust VCPU based on newNonSI.
        // let newVCPU = (newNonSI/500).toFixed(1);
        // data.VCPU = (data.VCPU*1 + newVCPU*1).toFixed(1);
        // data.ExadataVCPUAdjustmentText = `[Target was increased by ${newVCPU} VCPUs based on expected ${newNonSI.toFixed(0)}MB/s non-StorageIndex SmartScan workload returning to database] `;
        // data.cpu_target_comments=data.cpu_target_comments + `[adding ${newVCPU} VCPUs based on expected ${newNonSI.toFixed(0)}MB/s non-StorageIndex Exadata SmartScan workload returning to database] `;
        let ss_string='Moderate';
        let ss_si_ratio=3;
        if (prefs.smartscan_algo=='ss3') {
          ss_string='Heavy';
          ss_si_ratio=5;
        }
        if (prefs.smartscan_algo=='ss4') {
          ss_string='Very Heavy';
          ss_si_ratio=10;
        }
        if (prefs.smartscan_algo=='ss2a') {
          ss_string='Light';
          ss_si_ratio=2;
        }
        

        
        let newSI=data.DB_EXA_CELL_SI_SAVE_MB_P99/ss_si_ratio;
        let newNonSI=(data.DB_EXA_CELL_BYTES_ELIG_MB_P99-data.DB_EXA_CELL_SI_SAVE_MB_P99)/ss_si_ratio;
        //ThroughputMaxAverage may be higher than SSE because it includes non SSE items, so recalculte it
        let newThroughputMaxAverage = data.DB_IOMB_AVERAGE_P99-data.DB_EXA_CELL_BYTES_ELIG_MB_P99+newSI+newNonSI;
        //Throughput target value may be based on peaks as well as averages (but Exadata SSE, SI, etc are based on averages).  Scale the new throughput proportionally
        let newExadataRatio = data.DB_IOMB_AVERAGE_P99 / newThroughputMaxAverage;
        let newThroughput = data.Throughput / ss_si_ratio;
        
        data.iomb_target_comments=data.iomb_target_comments + `[using ${ss_string} post-Exadata SmartScan Tuning Assumption to estimate/reduce I/O Throughput target from ${data.Throughput}MB/s to ${newThroughput.toFixed(0)}MB/s] `;
        data.ExadataAdjustmentText=` [assumes ${ss_string} post-Exadata SmartScan Tuning to estimate/reduce I/O Throughput target from ${data.Throughput}MB/s to ${newThroughput.toFixed(0)}MB/s]`;
        data.Throughput = newThroughput.toFixed(0);
        data.ExadataAdjustment = ss_si_ratio;

        data.IOPS = (data.OrigIOPS / ss_si_ratio).toFixed(0);
        data.iops_target_comments=data.iops_target_comments + `[using ${ss_string} post-Exadata SmartScan Tuning Assumption to estimate/reduce IOPS target from ${data.OrigIOPS} to ${data.IOPS}] `;
        data.ExadataAdjustmentText=` [assumes ${ss_string} post-Exadata SmartScan Tuning to estimate/reduce I/O Throughput target from ${data.OrigThroughput}MB/s to ${data.Throughput}MB/s and IOPS target from ${data.OrigIOPS} to ${data.IOPS}]`;

        //also adjust VCPU based on newNonSI.
        if (!isNaN(newNonSI)) {
          let newVCPU = (newNonSI/500).toFixed(1);
          data.OrigVCPU = data.VCPU;
          data.VCPU = (data.VCPU*1 + newVCPU*1).toFixed(1);
          if (newVCPU*1>=0.5) {
            //only display if more than 0.5
            data.cpu_target_comments=data.cpu_target_comments + `[added an extra ${newVCPU} VCPUs based on expected ${newNonSI.toFixed(0)}MB/s non-StorageIndex Exadata SmartScan workload returning to database. Original VCPU target was ${data.OrigVCPU}] `;
          }  
          data.ExadataVCPUAdjustmentText = `[VCPU target was increased from ${data.OrigVCPU} by an extra ${newVCPU} VCPUs based on expected ${newNonSI.toFixed(0)}MB/s non-StorageIndex SmartScan workload returning to database] `;
        }
        
        
      } else {
      
         //do VCPU adjustment for ss1 scenario or for < 1000MB/s scenario
        if ((data.Exadata=='Yes')) {
          //also adjust VCPU based on newNonSI.
          let newNonSI = (data.DB_EXA_CELL_BYTES_ELIG_MB_P99-data.DB_EXA_CELL_SI_SAVE_MB_P99);
          if (!isNaN(newNonSI)) {
            let newVCPU = (newNonSI/500).toFixed(1);
            data.OrigVCPU = data.VCPU;
            data.VCPU = (data.VCPU*1 + newVCPU*1).toFixed(1);
            data.ExadataVCPUAdjustmentText = `[VCPU target was increased from ${data.OrigVCPU} by an extra ${newVCPU} VCPUs based on expected ${newNonSI.toFixed(0)}MB/s non-StorageIndex SmartScan workload returning to database] `;
            if (newVCPU*1>=0.5) {
              //only display if more than 0.5
              data.cpu_target_comments=data.cpu_target_comments + `[added an extra ${newVCPU} VCPUs based on expected ${newNonSI.toFixed(0)}MB/s non-StorageIndex Exadata SmartScan workload returning to database.  Original VCPU target was ${data.OrigVCPU}] `;
            }  
          }  
            // only show this note if >=1000 MB/s
          if (data.Throughput*1 >= prefs.smartscan_minimum*1) {
            data.iomb_target_comments=data.iomb_target_comments + `[This target value is based on the Exadata IO Throughput metrics unadjusted, which may be too high/pessimistic as it assumes the same amount of Full-table scans post-Exadata as on Exadata.  When moving off Exadata, the Oracle optimizer often chooses different execution plans and this target value may be larger than needed.  You can use the Assume post-SmartScan Tuning drop-down to use other algorithms to estimate different post-Exadata IO Throughput scenarios] `;
          }  
        }
      }

    //return Assumptions
    data.assumptionsArray = assumptionsArray;
    
    var assumptionsString = "";
    for (var i of assumptionsArray) {
      // assumptionsString is rendered as HTML; escape the text since some of it is user-entered (e.g. rdsSkipShape_expr)
      assumptionsString += "<b>"+i.category+"</b>: "+ i.text.replace(/&/g,"&amp;").replace(/</g,"&lt;")+". <br/>";
    }
    data.assumptionsString = assumptionsString;
    // console.log("assumptionsString", assumptionsString);
    
 return data;
  

}

function disclaimers (caller, callerDetail, params, regionInfo) {

  var theList=[];

  // China region disclaimers (at front for visibility)
  if (regionInfo && (regionInfo.region === 'cn-north-1' || regionInfo.region === 'cn-northwest-1')) {
    theList.push( "Prices are in Chinese Yuan, not US dollars.");
    theList.push( "DBCSI support for pricing for the Chinese AWS regions is beta and experimental. You should manually reconfirm pricing outside of DBCSI.");
  }

  theList.push( "DBCSI is developed and maintained by a database specialist solutions architect and is not officially supported by AWS."); 
  theList.push( "This sizing information is provided for budget estimates.  No warranties or guarantees.");
  theList.push(  "You should plan on refining the proper sizing during the performance testing phase of your migration.");
  theList.push(  "Estimated pricing does not account for backup costs, data transfer and other networking charges, T3/T4g Unlimited mode fees, AWS Support, etc.");

  if (caller != "ODB") {
    theList.push(  "Estimated pricing uses 1yr No Upfront Reserved Instances and Database Savings Plans if requested and available, and is based on the "+regionInfo.region+" prices as of "+regionInfo.lastUpdate+".");
  
    if ( (caller=='batch') || ( (caller=='metrics') && (callerDetail=='aurora') ) ) {
      if (params.aurora_algo!='auro1') {
        theList.push(  "The rough sizing estimate for Aurora is very ballpark and simply assumes the same VCPU and Memory targets while Throughput is mapped to the Network bandwidth of the Aurora compute shape.  Aurora Storage IO costs are based on the user-selected algorithm choices.");
      }  
    }  
    // console.log("disclaimers", params);
    if ( (caller=='batch') || ( (caller=='metrics') && (callerDetail=='elasticache') ) ) {
      if (params.caching_algo && params.caching_algo!='N') {
        theList.push(  "The rough sizing estimate for ElastiCache (and the related reduction in database requirements) is very ballpark and based on the user-selected algorithm choices.  You should plan on refining the overall sizing as part of your project.");
      }  
    }  
    // console.log("disclaimers", params);
    if ( (caller=='batch') || ( (caller=='metrics') && (callerDetail=='ec2fsxn') ) ) {
      if (params.ec2fsxn_algo && params.ec2fsxn_algo!='N') {
        theList.push(  "EC2 Bare Metal estimates do not include the cost of Oracle Linux Premier Support, which may be a requirement if you decide to use Oracle Linux Hypervisor Hard Partitioning.");
        theList.push(  "When running Oracle Database on EC2 Bare Metal instances, please consult with your internal licensing experts and/or third-party Oracle License advisory firms to better understand if concepts like Oracle Linux Hypervisor Hard Partitioning and Core Factor tables apply to your situation.  The DBCSI tool makes no suggestion either way.");
      }  
    }  
    if ( (caller=='batch') || ( (caller=='metrics') && (callerDetail=='ec2') ) ) {
      if (params.ec2_algo && params.ec2_algo!='N') {
        theList.push(  "EC2 estimates are for customer-managed EC2 instances and do not include Oracle Database licensing costs.");
        theList.push(  "EC2 storage estimates only include the storage of the database files, and do not account for backup, operating system, executable, or extra volumes used for additional redundancy.");
        theList.push(  "When running Oracle Database on EC2 instances, you are responsible for managing the database software, backups, patching, and high availability configurations.");
      }  
    }  
  
    theList.push(  "Oracle BYOL Licensing estimates are provided as a courtesy estimate, but you should refer to your internal Oracle licensing experts to validate based on your specific contract and legal position with Oracle Corporation.");
    if ( (params.optgoal_algo=='Y') && (caller!='shapes') ){
      theList.push(  "You should be aware that there is some debate in the community about how OptimizeCPU configurations should be counted by Oracle Licensing.  You may want to consult with third-party license advisors.  You can also tell DBCSI to ignore OptimizeCPU if that is your preference.");
    }
    if (params.use_se) {
      theList.push(  "When using License Included RDS-Oracle for Standard Edition2, please ensure that your application does NOT need Propietary Application Hosting rights from Oracle as they are not provided.");
    }  
    if (params.use_rac) {
      theList.push(  "The sizing and pricing functionality for RDS Custom for Oracle RAC is preliminary and not official.  Please validate any sizing and pricing with your AWS team.");
    }  
    
    if ( caller=='RDSConsolidation') {
        theList.push(  "The RDS Consolidation alternative is early preview functionality in DBCSI and subject to change.");
    }
  } 
  
  // Now do ODB disclaimers
  if ( (caller == "ODB") || ( (caller=="batch") && (params.odbAWS_algo=='Y') && (params.odbAWS_service=='adbs-tp') ) ) {
        theList.push( "DBCSI Sizing and cost estimates for Oracle Database@AWS Marketplace offering are for introductory discussion purposes only.  Consult with AWS and Oracle Corporation for further refinement.");
        theList.push( "Oracle Database@AWS is a Marketplace Offering with private pricing at the discretion of Oracle."); 
        theList.push( "ODB@AWS pricing estimate based on OCI list pricing as seen in the public OCI Cloud Cost Estimator as of July 1, 2026.");
        theList.push( "ODB@AWS Monthly estimate is based on 744 hours, which matches the OCI Cloud Cost Estimator.");
        if (params.odbAWS_service == 'adb') {
          theList.push( "Autonomous Database Usage estimation assumes steady CPU usage and does not try to account for CPU scaling, CPU overprovisioning, or elastic pools.");
        }
        if (params.odbAWS_service == 'adbs-tp') {
          theList.push( "Autonomous Database Serverless estimate assumes Autonomous Transaction Processing pricing.");
          theList.push( "Autonomous Database Serverless usage estimation assumes steady CPU usage and does not try to account for CPU scaling or elastic pools.");
          theList.push( "Autonomous Database Serverless sizing/pricing does not account for Data Lake Accelerator, Oracle Machine Learning, Graph Studio, Oracle Data Transforms, Refreshable Clones, Snapshot Standby for Remote, and Backup-based Disaster Recovery- use of which may increase usage or cost.");
        }
        
    
  }
  

  return theList;
}  

                              
// UI Helper Functions for Batch Table Popovers and Display Text

function computeCostOptimizationText(item, metric) {
  const metricName = metric.toUpperCase();
  const gapField = `gap_${metric}`;
  
  if (!item.targetconfig_rds?.[gapField]) return null;
  
  const currentValue = item[`Adjusted${metricName}`] || item[metricName];
  const gap = item.targetconfig_rds[gapField];
  const suggestedValue = metric === 'vcpu' 
    ? ((currentValue * 1) - gap).toFixed(0)
    : metric === 'throughput'
    ? ((currentValue * 1) - gap)
    : ((currentValue * 1) - gap);
  
  const unit = metric === 'memory' ? ' GB' : metric === 'throughput' ? ' MB/s' : metric === 'iops' ? ' IOPS' : '';
  
  return `Consider if you can reduce the ${metricName} from ${currentValue}${unit} to ${suggestedValue}${unit} to use a smaller shape. [ ${item.targetconfig_rds.closeness_string} ]`;
}

function combineWarnings(item, type) {
  const warnings = {
    alert: item.targetconfig_rds?.[`${type}_warnings_alert`] || '',
    burst: item.targetconfig_rds?.[`${type}_warnings_burst`] || '',
    info: [item[`${type}_target_comments`], item.targetconfig_rds?.[`${type}_warnings_info`]]
      .filter(Boolean).join(' ')
  };
  
  return warnings;
}

function computeExadataAdjustmentDescription(item) {
  if (item.Exadata !== 'Yes' || item.frozen_prefs == null || item.frozen_prefs.smartscan_algo === 'ss1') return null;
  
  const tuningLevelMap = { ss2a: 'LIGHT', ss2: 'MODERATE', ss3: 'HEAVY', ss4: 'VERY HEAVY' };
  const factorMap = { ss2a: '2', ss2: '3', ss3: '5', ss4: '10' };
  
  return {
    tuningLevel: tuningLevelMap[item.frozen_prefs.smartscan_algo??'ss2'],
    factor: factorMap[item.frozen_prefs.smartscan_algo??'ss2']
  };
}

function computePlatformAdjustmentDescription(item, form) {
  if (!item.PLATFORM_NAME || item.PLATFORM_NAME.includes('x86')) return null;
  
  const cpuThreadRatio = item.cpu_thread_ratio ?? form?.cpu_thread_ratio;
  return `The Average and Peak CPU Usage lines have been adjusted from the source system's threads (${item.PLATFORM_NAME}) to x86 VCPUs using the CPU Thread Ratio of ${cpuThreadRatio}.`;
}

function computeProratedCostExplanation(item) {
  if (!item.odb_shape || item.odb_total_monthly_estimate == 0) return null;
  
  return {
    title: 'Pro-Rated Cost Split/Allocation',
    content: `This is the total cost of the ODB@AWS Infrastructure and Usage split (pro-rated) across each individual database. This is for comparison purposes on a database-by-database level, but you should realize that this projected per-database cost is only valid if you bring all the databases in the set to ODB@AWS. The split is based on allocating the Usage costs by relative VCPU share, the DB Server costs by relative Memory share, and the Storage Server costs by relative Disk Space share. <br/><br/> ${item.odb_prorated_comments || ''}`,
    html: true
  };
}

function enrichBatchItemWithPopoverText(item, form) {
  // Cost optimization texts
  item.vcpu_cost_optimization_text = computeCostOptimizationText(item, 'vcpu');
  item.memory_cost_optimization_text = computeCostOptimizationText(item, 'memory');
  item.throughput_cost_optimization_text = computeCostOptimizationText(item, 'throughput');
  item.iops_cost_optimization_text = computeCostOptimizationText(item, 'iops');
  item.diskspace_cost_optimization_text = computeCostOptimizationText(item, 'diskspace');
  
  // Combined warnings
  item.vcpu_warnings = combineWarnings(item, 'cpu');
  item.memory_warnings = combineWarnings(item, 'memory');
  item.throughput_warnings = combineWarnings(item, 'iomb');
  item.iops_warnings = combineWarnings(item, 'iops');
  
  // Exadata and platform descriptions
  item.exadata_adjustment_desc = computeExadataAdjustmentDescription(item);
  item.platform_adjustment_desc = computePlatformAdjustmentDescription(item, form);
  item.prorated_cost_explanation = computeProratedCostExplanation(item);
  
  return item;
}

// ***********************************
// Summary: Older-generation cost adjustment used when ranking shapes by cost.
// Description: When the shape pickers (RDS, EC2, EC2+FSxN, Aurora) and the Shape Browser
//   compare costs, they compare cost * older_generation_factor instead of the raw cost.  That
//   makes an older generation look slightly more expensive, so a newer generation wins when its
//   real cost is roughly the same (e.g. an r8i that costs 4% more than an r7i is still picked,
//   because the r7i's cost is compared as 5% higher).  This only affects ranking - the costs we
//   report and use in the TCO are never adjusted.
//
//   The generation normally comes from the digit in the family name (r8i -> 8, m6g -> 6).
//   Some families' digits don't match the CPU generation they shipped with, so they are mapped
//   explicitly in OLDER_GENERATION_FAMILY_OVERRIDES.  Unknown/unparseable families get 1.0 so
//   we never penalize a shape we can't classify.
// ***********************************

// Factor by generation.  Generations newer than the highest key get 1.0; generations older
// than the lowest key get the lowest key's factor.
const OLDER_GENERATION_FACTORS = {
  8: 1.0,
  7: 1.05,
  6: 1.1,
  5: 1.15,
  4: 1.2
};

// Families whose name digit does not reflect the CPU generation (matched to the r/m/c
// generation that used the same CPU).
const OLDER_GENERATION_FAMILY_OVERRIDES = {
  i3: 4,      // Broadwell (r4 era)
  i3en: 5,    // Skylake/Cascade Lake
  i4i: 6,     // Ice Lake
  t3: 5,      // Skylake/Cascade Lake
  t4g: 6,     // Graviton2
  x1: 4,      // Haswell
  x1e: 4,     // Haswell
  x2g: 6,     // Graviton2
  x2idn: 6,   // Ice Lake
  x2iedn: 6,  // Ice Lake
  x2iezn: 5,  // Cascade Lake
  z1d: 5      // Skylake
};

// ***********************************
// Summary: Return the generation number for a shape (e.g. 8 for r8i.xlarge), or null if unknown.
// Parameters:
//   shape - a shape document from shapes.json, or a shape name (with or without a "db." prefix)
// Returns: generation number, or null
// ***********************************
function shape_generation (shape) {
  var name = (typeof shape === "string") ? shape : (shape && shape.Name);
  if (!name) return null;
  var family = name.replace(/^db\./, "").split(".")[0];
  if (Object.prototype.hasOwnProperty.call(OLDER_GENERATION_FAMILY_OVERRIDES, family)) {
    return OLDER_GENERATION_FAMILY_OVERRIDES[family];
  }
  var m = family.match(/^[a-z]+(\d+)/);
  return m ? parseInt(m[1], 10) : null;
}

// ***********************************
// Summary: Build a Skip Shape Filter regex (rdsSkipShape_expr) matching shapes of generation maxGen and older.
// Description: Mirrors shape_generation(): uses the family-name digit, except for families in
//   OLDER_GENERATION_FAMILY_OVERRIDES whose override decides instead.  The result avoids '*' because
//   the shape pickers convert '*' to '.*' for glob support.
// Parameters:
//   maxGen - highest generation to skip (1-9)
// Returns: regex string, e.g. "^(?!(?:i4i|t4g|x2g|x2idn|x2iedn)\.)[a-z]+[1-5]" for maxGen=5
// ***********************************
function older_generation_skip_pattern (maxGen) {
  var families = Object.keys(OLDER_GENERATION_FAMILY_OVERRIDES);
  var digitGen = function (family) { return parseInt(family.match(/^[a-z]+(\d)/)[1], 10); };
  // overridden families the digit test would get wrong in each direction
  var keep = families.filter(f => digitGen(f) <= maxGen && OLDER_GENERATION_FAMILY_OVERRIDES[f] > maxGen);
  var skip = families.filter(f => digitGen(f) > maxGen && OLDER_GENERATION_FAMILY_OVERRIDES[f] <= maxGen);
  var pattern = "[a-z]+[1-" + maxGen + "]";
  if (keep.length > 0) pattern = "(?!(?:" + keep.join("|") + ")\\.)" + pattern;
  if (skip.length > 0) pattern = "(?:" + pattern + "|(?:" + skip.join("|") + ")\\.)";
  return "^" + pattern;
}

// ***********************************
// Summary: Return the Skip Shape Filter presets (prefs.rdsSkipShape_preset) offered in the UI and public API.
// Description: key is the value of prefs.rdsSkipShape_preset, value is the regex it stands for, and text
//   is the description used in the UI and the assumptions.  An empty value means no filter.
// Returns: array of {key, value, text}
// ***********************************
function get_skip_shape_presets () {
  return [
    { key: "none", value: "", text: "Do not skip any shapes" },
    { key: "gen7_and_older", value: older_generation_skip_pattern(7), text: "Skip 7th generation and older shapes (e.g. r7i, m7i, r7g, r6i, r5)" },
    { key: "gen6_and_older", value: older_generation_skip_pattern(6), text: "Skip 6th generation and older shapes (e.g. r6i, m6i, r5, x2iedn, t4g)" },
    { key: "gen5_and_older", value: older_generation_skip_pattern(5), text: "Skip 5th generation and older shapes (e.g. r5, r5b, m5, z1d, t3)" },
    { key: "gen4_and_older", value: older_generation_skip_pattern(4), text: "Skip 4th generation and older shapes (e.g. i3, x1, x1e)" },
    { key: "amd", value: "^[a-z]+[0-9]a", text: "Skip AMD shapes (e.g. r6a, r7a, r8a, m7a)" },
    { key: "gen5_and_older_and_amd", value: older_generation_skip_pattern(5) + "|^[a-z]+[0-9]a", text: "Skip 5th generation and older shapes, and AMD shapes" },
  ];
}

// ***********************************
// Summary: Work out which Skip Shape Filter applies, from prefs.rdsSkipShape_preset and prefs.rdsSkipShape_expr.
// Description: A preset key (other than "" or "custom") wins over rdsSkipShape_expr.  Otherwise
//   rdsSkipShape_expr is used, and is reported as a preset when it is exactly a preset's regex
//   (batches saved before rdsSkipShape_preset existed).  Unknown preset keys are ignored here;
//   validate_skip_shape_prefs() reports them.
// Parameters:
//   prefs - preferences object
// Returns: {expr, preset} where expr is the regex string ("" = no filter) and preset is the
//   matching get_skip_shape_presets() entry or null
// ***********************************
function resolve_skip_shape_filter (prefs) {
  var presets = get_skip_shape_presets();
  var key = ((prefs && prefs.rdsSkipShape_preset) || "").trim();
  var preset = presets.find(p => p.key === key);
  if (preset) return {expr: preset.value, preset: preset.value === "" ? null : preset};

  var expr = ((prefs && prefs.rdsSkipShape_expr) || "").trim();
  preset = (expr === "") ? null : (presets.find(p => p.value === expr) || null);
  return {expr: expr, preset: preset};
}

// ***********************************
// Summary: Return the Skip Shape Filter as a RegExp for the shape pickers, or null when there is no filter.
// Description: Custom patterns that look like globs (contain '*' but not '.*') are converted to regex.
// Parameters:
//   prefs - preferences object (config.frozen_prefs in the shape pickers)
// Returns: RegExp or null.  Throws if rdsSkipShape_expr is not a valid regex.
// ***********************************
function get_skip_shape_regex (prefs) {
  var skipShape = resolve_skip_shape_filter(prefs);
  if (skipShape.expr === "") return null;
  var pattern = skipShape.expr;
  if (!skipShape.preset && pattern.includes('*') && !pattern.includes('.*')) {
    pattern = pattern.replace(/\*/g, '.*');
  }
  return new RegExp(pattern);
}

// ***********************************
// Summary: Validate rdsSkipShape_preset and rdsSkipShape_expr (used by the public API).
// Parameters:
//   prefs - preferences object
// Returns: error message, or "" if valid
// ***********************************
function validate_skip_shape_prefs (prefs) {
  var key = ((prefs && prefs.rdsSkipShape_preset) || "").trim();
  var keys = get_skip_shape_presets().map(p => p.key);
  if (key !== "" && key !== "custom" && !keys.includes(key)) {
    return "Unknown rdsSkipShape_preset '" + key + "'. Valid values are: custom, " + keys.join(", ");
  }
  try {
    get_skip_shape_regex(prefs);
  } catch (e) {
    return "Invalid rdsSkipShape_expr: " + e.message;
  }
  return "";
}

// ***********************************
// Summary: Return the older_generation_factor for a shape (1.0 for the newest generation).
// Parameters:
//   shape - a shape document from shapes.json, or a shape name
// Returns: multiplier >= 1.0
// ***********************************
function older_generation_factor (shape) {
  var gen = shape_generation(shape);
  if (gen === null) return 1.0;
  var gens = Object.keys(OLDER_GENERATION_FACTORS).map(Number);
  var newest = Math.max.apply(null, gens);
  var oldest = Math.min.apply(null, gens);
  if (gen >= newest) return OLDER_GENERATION_FACTORS[newest];
  if (gen <= oldest) return OLDER_GENERATION_FACTORS[oldest];
  return OLDER_GENERATION_FACTORS[gen];
}

// ***********************************
// Summary: Return cost * older_generation_factor(shape), for use in cost-ranking comparisons only.
// Parameters:
//   cost  - the hourly (or other) cost being compared
//   shape - a shape document from shapes.json, or a shape name
// Returns: adjusted cost
// ***********************************
function older_generation_cost_adjustment (cost, shape) {
  return cost * older_generation_factor(shape);
}

export {get_default_prefs};
export {calculate_target_values};
export {disclaimers};
export {enrichBatchItemWithPopoverText};
export {shape_generation};
export {older_generation_factor};
export {older_generation_cost_adjustment};
export {older_generation_skip_pattern};
export {get_skip_shape_presets};
export {resolve_skip_shape_filter};
export {get_skip_shape_regex};
export {validate_skip_shape_prefs};

